/**
 * Los atajos de teclado de Informes: Ctrl+S / Cmd+S (guardar) y Cmd+K (abrir otro informe).
 *
 * Vive fuera de `InformesPage` para poder testearlo sin montar la pantalla (que arrastra el router).
 *
 * Devuelve:
 *  - `'save'` / `'picker'`: lo que hace la pantalla;
 *  - `'save-from-text'`: guardar estando adentro de un bloque de texto. La pantalla primero le saca
 *    el foco al editor —su `onBlur` vuelca lo último que se escribió— y recién después abre el guardado;
 *  - `'swallow'`: no se abre nada, pero el atajo se consume (si no, Ctrl+S le pedía al navegador
 *    guardar la página, FE-13);
 *  - `null`: no es un atajo.
 */
export function shortcutFor(event, {modalOpen, activeElement}) {
    const meta = event.ctrlKey || event.metaKey;
    if (!meta) return null;
    const key = (event.key || '').toLowerCase();
    if (key !== 's' && key !== 'k') return null;
    if (modalOpen) return 'swallow';
    if (activeElement && activeElement.isContentEditable) {
        // El editor del bloque de texto también es `contentEditable`, y ahí Ctrl+S es el gesto natural
        // de guardar los insights que se acaban de escribir. Tragárselo como en el título dejaba
        // a quien escribe sin guardar y sin aviso (review C-agregar-bloque-texto-informes-02).
        if (key === 's' && isInTextBlock(activeElement)) return 'save-from-text';
        // El título editable: ahí un atajo no abre nada.
        return 'swallow';
    }
    return key === 's' ? 'save' : 'picker';
}

function isInTextBlock(element) {
    return !!(element && element.closest && element.closest('.inf-text-editor-content'));
}
